<template>
  <bootstrap-modal
    v-show="showModal"
  >
    <div
      slot="header"
      class="modal-header"
    >
      <button
        type="button"
        class="close modal__close-button"
        data-dismiss="modal"
        aria-label="Close"
        @click="handleCloseClick"
      >
        <span
          aria-hidden="true"
          class="retouching-modal__close-icon"
        >&times;</span>
      </button>
      <h4
        id="zoomModalLabel"
        class="modal-title"
      >
        <contentful-text :item="contentfulText('zoom-modal-title')" />
      </h4>
    </div>
    <div
      slot="body"
      class="modal-body"
    >
      <div class="row">
        <div class="col-xs-12">
          <p>
            <contentful-text :item="contentfulText('photo-label')" />
            {{ frame.FrameID }}
          </p>
        </div>
        <div class="col-xs-12">
          <img
            :src="imgUrl"
            class="responsive-img js-zoom-image"
            alt=""
          >
        </div>
      </div>
    </div>
  </bootstrap-modal>
</template>

<script>

import BootstrapModal from '@Shared/components/BootstrapModal'
import ContentfulMixn from '@Shared/mixins/contentful'
import selectionPlaceHolderImg from '@Shared/img/selection-placeholder.png'

export default {
  name: 'ZoomModal',
  components: {
    BootstrapModal
  },
  mixins: [
    ContentfulMixn
  ],
  props: {
    frame: { type: Object, defualt: null, required: true },
    show: { type: Boolean, defualt: false, required: true }
  },
  data () {
    return {
      showModal: false,
      selectionPlaceHolderImg
    }
  },
  computed: {
    imgUrl () {
      if (this.frame !== null) {
        return this.frame.Urls.SmallWatermarked
      } else {
        return this.selectionPlaceHolderImg
      }
    },
    content () {
      return this.$store.state.catalogPageCommon.zoomModalModuleContent
    }
  },
  watch: {
    show (v, ov) {
      this.showModal = v
    }
  },
  methods: {
    handleCloseClick () {
      this.$emit('close')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/catalog/ZoomModal/ZoomModal.vue